import React from 'react';
import { Box } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useLocation } from 'react-router-dom';
import PaginaSuscripcion from '../components/suscripcion/PaginaSuscripcion';
import TarjetaAU from '../components/suscripcion/TarjetaAU';
import EtiquetaAU from '../components/suscripcion/EtiquetaAU';
import CirculoIcono from '../components/suscripcion/CirculoIcono';
import { AU, FUENTE } from '../styles/tokensAU';

// Éxito del pago manual (/success-request) y de otros flujos que la reutilizan (/success). El correo y
// el tipo de trámite llegan por el estado del navegador.
const SuccessPage = () => {
  const location = useLocation();
  const email = location.state?.email || '';
  const tramite = location.state?.paymentOrSubscription || 'solicitud';

  return (
    <PaginaSuscripcion>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, textAlign: 'center', pt: 2 }}>
        <CirculoIcono><MailOutlineIcon /></CirculoIcono>
        <Box component="h1" sx={{ m: 0, fontFamily: FUENTE, fontSize: 26, fontWeight: 800, lineHeight: 1.15, color: AU.oscuro }}>
          ¡Solicitud exitosa!
        </Box>
        <Box sx={{ fontFamily: FUENTE, fontSize: 16, fontWeight: 600, color: AU.oscuro }}>
          Revisa tu correo electrónico:
        </Box>
      </Box>

      {email && (
        <TarjetaAU sx={{ textAlign: 'center' }}>
          <EtiquetaAU>Correo</EtiquetaAU>
          <Box sx={{ mt: 0.5, fontFamily: FUENTE, fontSize: 18, fontWeight: 700, color: AU.azulHover, overflowWrap: 'anywhere' }}>{email}</Box>
        </TarjetaAU>
      )}

      <Box sx={{ textAlign: 'center', fontFamily: FUENTE, fontSize: 15, color: AU.grisMedio }}>
        {`Te hemos enviado un email con los detalles de tu ${tramite}. Si no lo ves en tu bandeja de entrada, revisa la carpeta de spam o promociones.`}
      </Box>
    </PaginaSuscripcion>
  );
};

export default SuccessPage;
